import Api from "@/components/api/api";
import ToastProvider from "@/hooks/useToastProvider";
import { getUserData } from "@/redux/slices/userSlices";
import { ActivatedSubmitForm } from "@/utils/interface.global";
import {
  CheckCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input, Typography } from "@material-tailwind/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  VoucherParamsType,
  ListVoucher,
  ParamsType,
} from "@/utils/interface.global";
import * as Yup from "yup";

const formSchema = Yup.object().shape({
  name: Yup.string()
    .min(4, "Họ và tên phải có ít nhất 6 ký tự")
    .nullable()
    .transform((x) => (x === "" ? undefined : x))
    .notRequired(),
  phoneNumber: Yup.string()
    .min(10, "Số điện thoại phải có ít nhất 10 số")
    .nullable()
    .transform((x) => (x === "" ? undefined : x))
    .notRequired(),
  email: Yup.string()
    .email("Email không đúng")
    .transform((x) => (x === "" ? undefined : x))
    .nullable()
    .notRequired(),
  address: Yup.string()
    .min(6, "Địa chỉ phải có ít nhất 6 ký tự")
    .transform((x) => (x === "" ? undefined : x))
    .nullable()
    .notRequired(),
  code: Yup.string()
    .required("Mã Phiếu Thay Dầu không được để trống")
    .min(4, "Mã Phiếu Thay Dầu phải có ít nhất 4 ký tự"),
});

const Activated: React.FC = () => {
  const user = useSelector(getUserData);
  const [step, setStep] = useState(1);
  const [dataVoucher, setDataVoucher] = useState<null | any>(null);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ActivatedSubmitForm>({
    mode: "onTouched",
    resolver: yupResolver(formSchema),
  });

  const handleSubmitFormCheckVoucher = async (values: ActivatedSubmitForm) => {
    const { code } = values;
    console.log(code);
    const reqUrl = "/check-voucher";
    const params = { key: user.key_login, user_id: user.id, code: code };
    const res = await Api.post(reqUrl, params);
    if (res) {
      if (res.data.status == false) {
        ToastProvider({ type: "error", content: res.data.message });
      } else {
        ToastProvider({ type: "success", content: res.data.message });
      }
      setDataVoucher(res.data);
    }
  };

  const onCheckOtherVouchers = () => {
    setDataVoucher(null);
    setStep(1);
  };

  const onNextStepActiveVoucher = () => {
    //setStep(2);
    onActiveVoucherByPassData();
  };

  const onActiveVoucherByPassData = () => {
    //To do
    const params: ParamsType = {
      key: user.key_login,
      user_id: user.id,
      code: dataVoucher && dataVoucher.code,
      type: 1,
    };
    submitActiveVoucher(params);
  };

  const handleSubmitFormConfirm = (values: ActivatedSubmitForm) => {
    const { name, phoneNumber, address, email } = values;
    if (
      name == undefined ||
      phoneNumber == undefined ||
      address == undefined ||
      email == undefined
    ) {
      ToastProvider({
        type: "error",
        content:
          "Vui lòng nhập đầy đủ thông tin. Hoặc bấm bỏ qua nếu chưa đủ thông tin",
      });
    } else {
      const params: VoucherParamsType = {
        key: user.key_login,
        user_id: user.id,
        code: dataVoucher && dataVoucher.code,
        type: 2,
        kh_name: name,
        kh_phone: phoneNumber,
        kh_address: address,
        kh_email: email,
      };
      submitActiveVoucher(params);
    }
  };

  const submitActiveVoucher = async (params: ParamsType) => {
    const reqUrl = "/active-voucher";
    const res = await Api.post(reqUrl, params);
    if (res) {
      if (res.data.status == false) {
        ToastProvider({ type: "error", content: res.data.message });
      } else {
        ToastProvider({ type: "success", content: res.data.message });
        setDataVoucher(null);
        setStep(1);
        reset();
      }
    }
  };

  return (
    <>
      <div className="activated-container">
        <p>Mã Cửa Hàng</p>
        <h1 className="text-red-500 font-bold text-xl sm:text-3xl pt-2 pb-4">
          {user ? user.code_shop : <></>}
        </h1>
        <Input
          {...register("code")}
          variant="standard"
          color="gray"
          label="Mã Phiếu Thay Dầu"
          error={errors.code && true}
        />
        {errors.code && (
          <Typography
            variant="small"
            color="red"
            className="flex items-center gap-1 font-normal mx-2 mt-3"
          >
            <InformationCircleIcon className="w-4 h-4 -mt-px" />
            {errors.code.message as string}
          </Typography>
        )}
        {step == 1 ? ( //Mới nhập Mã voucher
          dataVoucher == null ? ( //Khi chưa nhập mã
            <>
              <button
                className="check-another-activated mt-6 font-bold"
                onClick={handleSubmit(handleSubmitFormCheckVoucher)}
              >
                Kiểm tra Phiếu Thay Dầu
              </button>
            </>
          ) : dataVoucher.status == true ? (
            <>
              <Typography
                variant="small"
                color="green"
                className="flex items-center justify-start gap-1 font-normal mx-2 mt-3"
              >
                <CheckCircleIcon className="w-4 h-4 -mt-px" />
                {dataVoucher.message}
              </Typography>
              <div className="flex flex-row gap-2">
                <button
                  className="check-time-activated mt-6 font-bold"
                  onClick={onCheckOtherVouchers}
                >
                  Kiểm Tra Phiếu Thay Dầu Khác
                </button>
                <button
                  className="check-another-activated mt-6 font-bold"
                  onClick={onNextStepActiveVoucher}
                >
                  Kích Hoạt Voucher
                </button>
              </div>
            </>
          ) : (
            <>
              <Typography
                variant="small"
                color="red"
                className="flex items-center justify-start gap-1 font-normal mx-2 mt-3"
              >
                <InformationCircleIcon className="w-4 h-4 -mt-px" />
                {dataVoucher.message}
              </Typography>
              <button
                className="check-another-activated mt-6 font-bold"
                onClick={handleSubmit(handleSubmitFormCheckVoucher)}
              >
                Kiểm tra Phiếu Thay Dầu
              </button>
            </>
          )
        ) : (
          <></>
        )}
      </div>
      {step == 2 ? (
        <>
          {/* Form Nhập Thông Tin Khách hàng */}
          <div className="flex flex-col font-bold">
            <h1>Nhập Thông Tin Khách Hàng</h1>
            <div className="flex flex-col sm:flex-row pt-4 gap-4">
              <div className="w-1/2">
                <Input
                  {...register("name")}
                  variant="standard"
                  color="gray"
                  type="text"
                  label="Họ Và Tên (Không bắt buộc)"
                  error={errors.name && true}
                />
                {errors.name && (
                  <Typography
                    variant="small"
                    color="red"
                    className="flex items-center gap-1 font-normal mx-2 mt-3 text-xs"
                  >
                    <InformationCircleIcon className="w-3 h-3 -mt-px" />
                    {errors.name.message as string}
                  </Typography>
                )}
              </div>
              <div className="w-1/2">
                <Input
                  {...register("phoneNumber")}
                  variant="standard"
                  color="gray"
                  type="text"
                  label="Điện Thoại (Không bắt buộc)"
                  error={errors.phoneNumber && true}
                />
                {errors.phoneNumber && (
                  <Typography
                    variant="small"
                    color="red"
                    className="flex items-center gap-1 font-normal mx-2 mt-3 text-xs"
                  >
                    <InformationCircleIcon className="w-3 h-3 -mt-px" />
                    {errors.phoneNumber.message as string}
                  </Typography>
                )}
              </div>
            </div>
            <div className="flex flex-col pt-4">
              <div className="pb-4">
                <Input
                  {...register("email")}
                  variant="standard"
                  color="gray"
                  type="email"
                  label="Email (Không bắt buộc)"
                  error={errors.email && true}
                  className="mb-3"
                />
                {errors.email && (
                  <Typography
                    variant="small"
                    color="red"
                    className="flex items-center gap-1 font-normal mx-2 my-3 text-xs"
                  >
                    <InformationCircleIcon className="w-3 h-3 -mt-px" />
                    {errors.email.message as string}
                  </Typography>
                )}
              </div>
              <div className="pb-4">
                <Input
                  {...register("address")}
                  variant="standard"
                  color="gray"
                  type="text"
                  label="Địa Chỉ (Không bắt buộc)"
                  error={errors.address && true}
                />
                {errors.address && (
                  <Typography
                    variant="small"
                    color="red"
                    className="flex items-center gap-1 font-normal mx-2 my-3 text-xs"
                  >
                    <InformationCircleIcon className="w-3 h-3 -mt-px" />
                    {errors.address.message as string}
                  </Typography>
                )}
              </div>
            </div>
            <div className="flex gap-4 pt-5">
              <button
                className="check-time-activated w-1/2"
                onClick={onActiveVoucherByPassData}
              >
                Bỏ Qua
              </button>
              <button
                className="check-another-activated w-1/2"
                onClick={handleSubmit(handleSubmitFormConfirm)}
              >
                Xác Nhận
              </button>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Activated;
